import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import SubLayout from './Layout/SubLayout';
import Login from './Pages/Login';
import PlanningBuild from './Pages/PlanningBuild';
import PlanningBuildFilter from './Pages/PlanningBuildFilter';
import RangeTable from './Pages/RangeTable';
import UserManagement from './Pages/UserManagement';
import SubRegister from './Pages/SubRegister';
import PlanningBuildLayout from './Layout/PlanningBuildLayout';
import Dashboard from './Pages/Dashboard';
import ForgotPassword from './Pages/ForgotPassword';
import NewPassword from './Pages/NewPassword';
import Otp from './Pages/Otp';
import Templates from './Pages/Templates';
import Profile from './Pages/MyProfile';
import PrivateRoute from './Routes/PrivateRoute';
import { SnapshotProvider } from './Components/SnapshotContext';
import AdminRoute from './AdminRoute';

function App() {
  return (
    <BrowserRouter>
    <SnapshotProvider>
      <Routes>
      <Route index element={<Login />} />
      <Route 
        path="forgot-password"
        element={
        <ForgotPassword />
      } 
        
        />
      <Route path="/reset-password"  element={
        <NewPassword/>
        // <PrivateRoute
        //       condition={localStorage.getItem("emailEntered") === "true"}
        //     >
        //       <NewPassword />
        //     </PrivateRoute>
        }
        />
      {/* <Route path="otp"  element={<Otp />} /> */}
      
      
        
        <Route 
        path="/spaceSelect" 
        element={<PrivateRoute><PlanningBuildLayout /></PrivateRoute>}
        >
          <Route index element={<PlanningBuild />} />
          <Route path="planning-to-theater" element={<PlanningBuildFilter />} />
          <Route path="range-table" element={<RangeTable />} />
          <Route 
          path="user-management" 
          // element={<UserManagement />}
          element={<AdminRoute />}
           >
            <Route index element={<UserManagement/>}></Route>
          </Route>

          <Route path="templates" element={<Templates />} />
          <Route path="my-profile" element={<Profile />} />
        </Route>

        <Route path="dashboard" element={<PrivateRoute><SubLayout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          {/* <Route path="templates" element={<Templates />} /> */}
         
          <Route path="blogs" element={<SubRegister />} />
        </Route>

      </Routes>
      </SnapshotProvider>
    </BrowserRouter>
  );
}

export default App;
